module.exports = __webpack_public_path__ + "img/mic4.a66eb3ae.jpg";